'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isEmpty = isEmpty;
function isEmpty(object) {
  switch (typeof object === 'undefined' ? 'undefined' : _typeof(object)) {
    case 'string':
      return object.length === 0;
    case 'object':
      return object === null ? true : Array.isArray(object) ? object.length === 0 : Object.keys(object).length === 0;
    default:
      return true;
  }
}